import { chainFns } from '../utils/chainFns'
import { setStyle } from '../utils/setStyle'

export function preventScrollStandard(): () => void {
  return chainFns(
    setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`),
    setStyle(document.documentElement, 'overflow', 'hidden')
  )
}
